import * as React from "react";
import * as styles from "./login-box.css";
import { actionCreators } from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import { getPersonalDatesFromGroup } from "ui/helper";
import AnimateHeight from "react-animate-height";
import LoginForm from "./login-form";
import RegisterForm from "./register-form";
import ResetForm from "./reset-form";
import { PersonalDatePresentationItem } from "burde";
import { getDatesets, getLatestPersonalDateGroup } from "calendar/service";
import { useEffect, useState } from "react";

type LoginBoxProps = {
    getResource: (key: string) => string;
    showLoginModal: boolean;
    login: (user: any) => any;
    updatePersonalDateInfo: (
        personalDates: Array<PersonalDatePresentationItem>,
    ) => any;
    domain: string;
} & typeof uiActionCreators &
    typeof actionCreators;

type LoginState = {
    isLogin: boolean;
    isRegister: boolean;
    isReset: boolean;
};

const LoginBox: React.FC<LoginBoxProps> = ({
    showLoginModal,
    login,
    updateShowLoginModal,
    UpdateShowUserMenu,
    getResource,
    updatePersonalDateInfo,
    domain,
}) => {
    const [loginState, setLoginState] = useState<LoginState>({
        isLogin: true,
        isRegister: false,
        isReset: false,
    });

    const getAndSetLatestPersonalDates = async () => {
        const personalDates = await getDatesets();

        updatePersonalDateInfo(personalDates !== null ? personalDates : []);
    };

    return (
        <>
            {showLoginModal && (
                <>
                    <div
                        className={[
                            styles.modalBox,
                            showLoginModal ? styles.modalBoxShow : "",
                        ].join(" ")}>
                        <button
                            className={styles.modalCloseButton}
                            onClick={() => updateShowLoginModal(false)}>
                            <i className={"fas fa-times"} />
                        </button>
                        <div
                            className={styles.modalImage}
                            style={{
                                backgroundImage:
                                    "url(./images/cover/photo-blue-flower.jpg)",
                            }}
                        />
                        <div className={styles.modalBody}>
                            <AnimateHeight
                                duration={250}
                                height={loginState.isRegister ? "auto" : 0}
                                animateOpacity={true}>
                                <RegisterForm
                                    getResource={getResource}
                                    login={login}
                                    onSuccessfulRegister={() => {
                                        updateShowLoginModal(false);
                                        UpdateShowUserMenu(true);
                                    }}
                                    swapToLoginClick={() =>
                                        setLoginState({
                                            isRegister: false,
                                            isLogin: true,
                                            isReset: false,
                                        })
                                    }
                                    domain={domain}
                                />
                            </AnimateHeight>
                            <AnimateHeight
                                duration={250}
                                height={loginState.isLogin ? "auto" : 0}
                                animateOpacity={true}>
                                <LoginForm
                                    getResource={getResource}
                                    login={login}
                                    onSuccessfulLogin={() => {
                                        updateShowLoginModal(false);
                                        UpdateShowUserMenu(true);
                                        getAndSetLatestPersonalDates();
                                    }}
                                    swapToRegisterClicked={() =>
                                        setLoginState({
                                            isRegister: true,
                                            isLogin: false,
                                            isReset: false,
                                        })
                                    }
                                    domain={domain}
                                />
                            </AnimateHeight>
                            <AnimateHeight
                                duration={250}
                                height={loginState.isReset ? "auto" : 0}
                                animateOpacity={true}>
                                <ResetForm
                                    getResource={getResource}
                                    swapToLoginClicked={() => {
                                        setLoginState({
                                            isRegister: false,
                                            isLogin: true,
                                            isReset: false,
                                        });
                                    }}
                                />
                            </AnimateHeight>
                        </div>
                    </div>
                    <div
                        className={showLoginModal ? styles.overlay : ""}
                        onClick={() => updateShowLoginModal(false)}
                    />
                </>
            )}
        </>
    );
};

export default LoginBox;
